import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Portfolio from "../pages/portfolio/page";
import Sectors from "../pages/sectors/page";
import WorldCup from "../pages/worldcup/page";
import TireTechnology from "../pages/tire-technology/page";
import Contact from "../pages/contact/page";
import Diitect from "../pages/diitect/page";
import Vetuvia from "../pages/vetuvia/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/sectors",
    element: <Sectors />,
  },
  {
    path: "/world-cup",
    element: <WorldCup />,
  },
  {
    path: "/tire-technology",
    element: <TireTechnology />,
  },
  {
    path: "/diitect",
    element: <Diitect />,
  },
  {
    path: "/vetuvia",
    element: <Vetuvia />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
